import ToggleButton from './toggle-button-component';
import './toggle-button.scss';

const MODULE_NAME = 'app.common.widgets.toggle-button';
const module = angular.module(MODULE_NAME, [])
    .directive(ToggleButton.DIRECTIVE_NAME, ToggleButton);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/common/widgets/toggle-button/toggle-button-module.js